import { Container, Box, Typography, Grid, TextField, InputLabel, IconButton, Button, Switch, Backdrop, CircularProgress, Select, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { Controller } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useUtiles } from '../../../../shared/context/utilesContext';

import SelectLocationComponent from '../../components/SelectLocationComponent';
import SelectClassificationComponent from '../../components/SelectClassificationComponent';
import ClearIcon from '@mui/icons-material/Clear';
import { useEquipment } from '../../../../shared/context/equipmentContext';
import { SelectTypeEquipmentComponent } from '../../components/SelectTypeEquipmentComponent';
import { useEffect } from 'react';
import { useAbility } from '../../../../shared/context/AbilityContext';

export default function CreateUpdateEquipmentView() {
    const theme = useTheme()
    const navigate = useNavigate()
    const { locationString, toogleOpenSilder, priorityOptions } = useUtiles() 

    const ability = useAbility();
    useEffect(() => {
        if (!ability.can('create', 'ASSETS.EQUIPMENTS') && !ability.can('update', 'ASSETS.EQUIPMENTS')) {
            navigate('/')
        }
    }, [ability])

    const hash = useParams().hash

    const { equipment,
        setEquipment,
        resetEquipment,
        setSelectLocationParent,
        setSelectClassification1,
        setSelectClassification2,
        setSelectTypeEquipment,
        createEquipment,
        loadingCreateEquipment,
        getEquipmentByHash,
        loadingUpdateEquipment,
        updateEquipment,
        loadingGetEquipmentByHash
    } = useEquipment()

    const { control, handleSubmit, formState: { errors }, setValue } = useForm({
        defaultValues: {
            location: '',
            name: '',
            code: '',
            manufacturer: '',
            model: '',
            serial: '',
            type_equipment: '',
            date_acquisition: '',
            priority: '',
            classification1: '',
            classification2: '',
            enabled: true,
            notes: '',
            otro1: '',
            otro2: '',
        }
    })


    const handleFieldChange = (name, value) => {
        setValue(name, value)
        setEquipment({ ...equipment, [name]: value })
    }


    const handleClearSelected = (field) => {
        setEquipment({ ...equipment, [field]: null })
        setValue(field, null)
    }

    const handleCreateEquipment = async () => {
        if (equipment.id) {
            await updateEquipment()
        } else {
            await createEquipment()
        }
    }

    useEffect(() => {
        if (hash) {
            getEquipmentByHash(hash)
        }
    }, [hash])


    useEffect(() => {
        if (equipment.id) {
            setValue('location', equipment.location)
            setValue('name', equipment.name)
            setValue('code', equipment.code)
            setValue('manufacturer', equipment.manufacturer)
            setValue('model', equipment.model)
            setValue('serial', equipment.serial)
            setValue('type_equipment', equipment.type_equipment)
            setValue('date_acquisition', equipment.date_acquisition)
            setValue('priority', equipment.priority)
        }
    }, [equipment])


    


    return (
        <Container maxWidth="xl" sx={{
            padding: '0px', margin: '0px',
        }}>

            <form onSubmit={handleSubmit(handleCreateEquipment)}>

            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px'
            }}>
                <IconButton
                    onClick={() => navigate('/activos/equipos')}
                    sx={{
                        borderRadius: '12px',
                        padding: '8px',
                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>

                <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    type='submit'
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',

                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Guardar
                </Button>
            </Box>






            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: '20px'
            }}>
                <Typography variant="h6" sx={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    fontSize: '20px',
                }}>
                    {equipment.id ? 'Editar Equipo' : 'Crear Equipo'}
                </Typography>


                <Grid container spacing={2} columns={12}>
                    <Grid item size={{ xs: 12 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Ubicado en :</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }} >
                            Seleccione la ubicación jerárquica superior a la que estará vinculada esta localización
                        </Typography>
                        <Controller
                            control={control}
                            name="location"
                            render={({ field }) => (
                                <Box sx={{ position: 'relative', width: '100%' }}>
                                    <TextField
                                        value={locationString(equipment[field.name]) || ''}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        fullWidth
                                        onClick={() => toogleOpenSilder(<SelectLocationComponent setSelectLocationParent={setSelectLocationParent} />, 600, 'Seleccionar Ubicación')}
                                        slotProps={{
                                            input: {
                                                readOnly: true,
                                            }
                                        }}
                                    />
                                    {equipment[field.name] && (
                                        <IconButton
                                            size="small"
                                            onClick={() => handleClearSelected(field.name)}
                                            sx={{
                                                position: 'absolute',
                                                right: '8px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 2
                                            }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            )}
                        />
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Nombre <span style={{ color: 'red' }}>*</span></InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }} >
                            Denominación principal que identificará este equipo en el sistema
                        </Typography>
                        <Controller
                            control={control}
                            name="name"
                            rules={{ required: "Este campo es requerido" }}
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    error={!!errors.name}
                                    helperText={errors.name?.message}
                                    placeholder='Ingrese el nombre del equipo'
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Código <span style={{ color: 'red' }}>*</span></InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Identificador alfanumérico único para referenciar este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="code"
                            rules={{ required: "Este campo es requerido" }}
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    error={!!errors.code}
                                    helperText={errors.code?.message}
                                    placeholder='Ingrese el código del equipo'
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Fabricante</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Nombre del fabricante o proveedor de este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="manufacturer"
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    error={!!errors.manufacturer}
                                    helperText={errors.manufacturer?.message}
                                    placeholder='Ingrese el fabricante del equipo'
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Modelo</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Denominación o descripción del modelo de este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="model"
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    error={!!errors.model}
                                    helperText={errors.model?.message}
                                    placeholder='Ingrese el modelo del equipo'
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Número de Serie</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Número de serie o identificador único de este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="serial"
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    placeholder='Ingrese el número de serie del equipo'
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Tipo de Equipo</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Categoría o tipo de equipo que representa este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="type_equipment"
                            render={({ field }) => (
                                <Box sx={{ position: 'relative', width: '100%' }}>
                                    <TextField
                                        value={equipment[field.name]?.name || ''}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        placeholder='Ingrese el tipo de equipo'
                                        onClick={() => toogleOpenSilder(<SelectTypeEquipmentComponent setSelectTypeEquipment={setSelectTypeEquipment} />, 600, 'Seleccionar Tipo de Equipo')}
                                    slotProps={{
                                        input: {
                                            readOnly: true,
                                            }
                                        }}
                                    />
                                    {equipment[field.name] && (
                                        <IconButton
                                            size="small"
                                            onClick={() => handleClearSelected(field.name)}
                                            sx={{
                                                position: 'absolute',
                                                right: '8px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 2
                                            }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Fecha de Adquisición</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Fecha en que se adquirió este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="date_acquisition"
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    type="date"
                                    fullWidth
                                    variant="outlined"
                                    error={!!errors.date_acquisition}
                                    helperText={errors.date_acquisition?.message}
                                    placeholder='Ingrese la fecha de adquisición del equipo'
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Prioridad</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Nivel de importancia o prioridad asignada a este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="priority"
                            render={({ field }) => (
                                <Select
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    error={!!errors.priority}
                                    helperText={errors.priority?.message}
                                    placeholder='Ingrese la prioridad del equipo'
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
                                        },
                                    }}
                                >
                                    {priorityOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value} sx={{display: 'flex', alignItems: 'center'}}>
                                            {option.icon}
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Clasificación 1</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Primera clasificación o categoría de este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="classification1"
                            render={({ field }) => (
                                <Box sx={{ position: 'relative', width: '100%' }}>
                                    <TextField
                                        value={equipment[field.name]?.value || ''}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        error={!!errors.classification1}
                                        placeholder='Ingrese la clasificación 1 del equipo'
                                        helperText={errors.classification1?.message}
                                        onClick={() => toogleOpenSilder(<SelectClassificationComponent type_asset='equipments' number={1} setSelectClassification={setSelectClassification1} />, 600, 'Seleccionar Clasificación')}
                                        slotProps={{
                                            input: {
                                                readOnly: true,
                                            }
                                        }}
                                    />
                                    {equipment[field.name] && (
                                        <IconButton
                                            size="small"
                                            onClick={() => handleClearSelected(field.name)}
                                            sx={{
                                                position: 'absolute',
                                                right: '8px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 2
                                            }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Clasificación 2</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Segunda clasificación o categoría de este equipo
                        </Typography>
                        <Controller
                            control={control}
                            name="classification2"
                            render={({ field }) => (
                                <Box sx={{ position: 'relative', width: '100%' }}>
                                    <TextField
                                        value={equipment[field.name]?.value || ''}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        placeholder='Ingrese la clasificación 2 del equipo'
                                        helperText={errors.classification2?.message}
                                        onClick={() => toogleOpenSilder(<SelectClassificationComponent type_asset='equipments' number={2} setSelectClassification={setSelectClassification2} />, 600, 'Seleccionar Clasificación')}
                                    />
                                    {equipment[field.name] && (
                                        <IconButton
                                            size="small"
                                            onClick={() => handleClearSelected(field.name)}
                                            sx={{
                                                position: 'absolute',
                                                right: '8px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 2
                                            }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            )}
                        />
                    </Grid>
                    
                    <Grid item size={{ xs: 12 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Notas</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>    
                            Campo opcional para almacenar información adicional
                        </Typography>
                        <Controller
                            control={control}
                            name="notes"
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    placeholder='Ingrese las notas del equipo'
                                    multiline
                                    rows={4}
                                />
                            )}
                        />
                    </Grid> 

                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Otro 1</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>    
                            Campo opcional para almacenar información adicional
                        </Typography>
                        <Controller
                            control={control}
                            name="otro1"
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    placeholder='Ingrese el otro 1 del equipo'
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Otro 2</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>    
                            Campo opcional para almacenar información adicional
                        </Typography>
                        <Controller
                            control={control}
                            name="otro2"    
                            render={({ field }) => (
                                <TextField
                                    value={equipment[field.name] || ''}
                                    onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    placeholder='Ingrese el otro 2 del equipo'
                                />
                            )}
                        />
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Habilitado</InputLabel>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                            Indica si este equipo está habilitado para su uso
                        </Typography>
                        <Controller
                            control={control}
                            name="enabled"
                            render={({ field }) => (
                                <Switch
                                    checked={equipment.enabled}
                                    onChange={(e) => handleFieldChange('enabled', e.target.checked)}
                                />
                            )}
                        />
                    </Grid>

                </Grid>
            </Box>
            </form>


            <Backdrop open={loadingCreateEquipment}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
                        Creando ubicación...
                    </Typography>
                    <CircularProgress />
                </Box>
            </Backdrop> 


            {
                loadingGetEquipmentByHash && (
                    <Backdrop open={loadingGetEquipmentByHash}>
                        <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
                            Cargando ubicación...
                        </Typography>
                        <CircularProgress />
                    </Backdrop>
                )
            }

        </Container>
    )
}